<script lang="ts">
  import { dev } from "$app/environment";
  import { test_social_share_images } from "$config";
  import { PUBLIC_PROJECT } from "$env/static/public";

  export let id: string;
  export let name: string;
  export let handle: string;
  export let title: string = "Community Showcase";
  export let description: string = `A collection of Craft Roulette content contributed by ${name}`;

  const formatted_title = `${title} - Community Showcase`;
  const siteName: string = "CraftRoulette.live";
  let url_string: string = `https://craftroulette.live/community/${handle}`;
  let image_url: string = `${PUBLIC_PROJECT}/api/images/social/community-showcase?id=${id}`;
</script>

<svelte:head>
  <title>{formatted_title} - Craft Roulette</title>
  <meta name="robots" content="all" />
  <meta name="title" content="{title} - Community Showcase - {siteName}" />
  <meta name="description" content={description} />

  <meta property="og:type" content="website" />
  <meta property="og:url" content={url_string} />
  <meta property="og:title" content="{formatted_title} - {siteName}" />
  <meta property="og:description" content={description} />

  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content={url_string} />
  <meta property="twitter:title" content="{formatted_title} - {siteName}" />
  <meta property="twitter:description" content={description} />

  <meta property="twitter:image" content={image_url} />
  <meta property="og:image" content={image_url} />

  <link rel="canonical" href={url_string} />
</svelte:head>

{#if test_social_share_images && dev}
  <div class="tester">
    <img src={image_url} alt="test social share graph" />
  </div>
{/if}

<style>
.tester {
  position: fixed;
  bottom: 2rem;
  left: 2rem;
  width: 600px;
  height: auto;
  z-index: 1000;
}
.tester img {
  width: 100%;
  height: auto;
  border: 1px solid #333;
  border-radius: 5px;
}
</style>
